import { render, staticRenderFns } from "./PointEarn.vue?vue&type=template&id=45e77486&"
import script from "./PointEarn.vue?vue&type=script&lang=js&"
export * from "./PointEarn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports